import { addEtiqueta } from './addEtiqueta'
import { getAll } from './getEtiquetas'

export const etiquetaService = {
  add: addEtiqueta,
  getAll,
}
